module.exports = __webpack_public_path__ + "static/media/306144.25da5659.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/306144.pdf
// module id = 878
// module chunks = 0